import { EditorFilter } from "../types";

// // // //

/**
 * clearFilterMessages
 * Clears the messages array in an EditorFilter and its nested filters recursively.
 * @function clearFilterMessages
 * @param {EditorFilter} filter - The EditorFilter to clear the messages from.
 * @returns {void}
 */
export function clearFilterMessages(filter: EditorFilter): EditorFilter {
    filter.messages = [];

    filter.nested.forEach((nestedFilter) => {
        clearFilterMessages(nestedFilter); // Recursively clear messages in nested filters
    });
    return filter;
}
